import React from 'react';
import { Box, Typography, Container, Divider, Grid } from '@mui/material';
import { masterlayoutbg } from '../../../../../assets';
import { ConnectedLiving } from '../ProjectInterface';
import SpecificationLightbox from './SpecificationsLightBox';

interface ConnectedLivingProps {
  connectedliving: ConnectedLiving | null;
  projectTitle?: string;
}

const CDN_URL =
  process.env.NEXT_PUBLIC_STORAGE_DN_URL || 'https://dprstorage.b-cdn.net';

const resolveImageUrl = (path: string) => {
  if (!path) return '';
  return path.startsWith('http') ? path : `${CDN_URL}${path}`;
};

const ConnectedLivingSection: React.FC<ConnectedLivingProps> = ({
  connectedliving,
  projectTitle,
}) => {
  const isValid =
    connectedliving &&
    connectedliving.locationimage &&
    connectedliving.data?.length > 0;

  const handleImageClick = () => {
    if (projectTitle?.toLowerCase().includes('vibrant')) {
      window.open(
        'https://maps.app.goo.gl/Fm871f5TuCLpPKcm6?g_st=iwb',
        '_blank',
      );
    }
  };

  return (
    <Box sx={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 'auto',
          backgroundImage: `url(${masterlayoutbg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            zIndex: 1,
          }}
        />

        <Box         
          sx={{
            position: 'relative',
            width: '100%',
            zIndex: 2,
            pt: { xs: 6, md: 4 },
            py: {xs:3, md: 4},
          }}
        >
          <Container maxWidth="xl">
            <Box sx={{ textAlign: 'center', color: 'white', mb: 2 }}>
              <Typography variant="h4" fontWeight={600} sx={{ color: 'white',fontFamily: 'Futura,  sans-serif !important',
            letterSpacing:"2px" }}>
                CONNECTED LIVING
              </Typography>
              <Box
                          sx={{
                            width: {
                              xs: "120px",
                              md: "180px",
                            },
              
                            height: "2px",
              
                            background:
                              "linear-gradient(to right, transparent, #fff, transparent)",
              
                            mx: "auto",
              
                            mb: 2,
                            mt:2
                          }}
                        />
              
            </Box>

            {!isValid ? (
              <Typography
                variant="body2"
                sx={{
                  color: 'white',
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 300,
                  letterSpacing: 0.5,
                  mt: 1                  ,
                }}
              >
                Connected living data is not uploaded.
              </Typography>
            ) : (
              <Grid
                container
                spacing={4}
                sx={{ justifyContent: 'center', alignItems: 'center' }}
              >
                {/* Image column */}
                <Grid
                  item
                  xs={12}
                  md={7}
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: 600,
                      borderRadius: 2,
                      overflow: 'hidden',
                      cursor: 'pointer',
                    }}
                    onClick={handleImageClick}
                  >
                    <img
                      src={resolveImageUrl(connectedliving.locationimage)}
                      alt="Connected Living Map"
                      style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: 8,
                      }}
                    />
                  </Box>
                </Grid>

                {/* Feature list column */}
                <Grid item xs={12} md={5}>
                  <Grid container spacing={1} sx={{ mt: 1, textAlign: 'left' }}>
                    {connectedliving.data.map((group, index) => (
                      <Grid item xs={12} key={index} sx={{ mt: 3 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: '600',
                            fontSize: '18px',
                            color: 'white',
                            mb: 1,
                            fontFamily: 'Futura,  sans-serif !important',
            letterSpacing:"1px"
                          }}
                        >
                          {group.type}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '12px',
                            color: '#f5f5f5',
                            fontWeight: '300',
                            fontFamily: 'LEMON MILK',
                            letterSpacing: '1px',
                          }}
                        >
                          {group.data.map((item, i) => (
                            <React.Fragment key={i}>
                              {item.time} mins - {item.h1} <br />
                            </React.Fragment>
                          ))}
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>


                </Grid>
              </Grid>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
              <SpecificationLightbox projectTitle={projectTitle} />
            </Box>

            {/* ✅ Specifications Button — Only if project title includes "vibrante" */}
            {/* {projectTitle?.toLowerCase().includes('vibrante') && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                      <SpecificationLightbox projectTitle={projectTitle} />
                    </Box>
                  )} */}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default ConnectedLivingSection;
